<template>
    <router-view ></router-view>
</template>

<style scoped>

    .hide {
        display: none;
    }

    .view {

        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 60px 23px 0 23px;
    }

    .authenticated-no-subscription #purchase-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription #connect-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription .time-block * {

        color: #fff;

    }

    .authenticated-no-subscription .no-subscription {

        position: absolute;
        top: 158px;
        left: 0;
        right: 0;
        margin: auto;
        width: 160px;
        padding: 3px;
        border-radius: 3px;
        border: 1px solid orange;
        color: orange;
        text-align: center;
        font-size: 14px;
    }

    .not-authenticated #purchase-button {

        width: 230px !important;
        position: relative;
        margin: 0 auto;

    }

    #container {

        background: #444;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

    }

    .sign-out {

        position: absolute;
        right: 15px;
        top: 10px;
        color: #fff;
        font-size: 14px;
        font-weight: 200;

    }

    .action-button{
        width: 170px!important;
        border-radius: 50px!important;
    }

    .account-name {

        position: absolute;
        left: 10px;
        top: -7px;
        color: #fff;
        font-size: 14px;
        font-weight: 400;

    }




</style>

<script>


    
	export default {
        name: 'Home',
        props: ['user'],
        created(){

            this.$vuetify.rtl = false;
        },
        async beforeMount() {





		}
    }
</script>
